import React, { forwardRef, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import * as Icons from "react-bootstrap-icons";
import MButton from "Utils/Helpers/MButton";
import Tooltip from "@mui/material/Tooltip";
import Inputer from "Utils/Helpers/Inputer";
import { useSetState } from "Utils/Helpers/Hooks";
import { Grid2 } from "@mui/material";
import { decodeText } from "Utils/Helpers/TextDecoder";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function Help({}) {
  const [show, setShow] = useState(false);
  const [controls, setControls] = useSetState({
    text: {
      display: true,
      label: "Test your self",
      type: "text",
      multiLine: false,
      placeholder: "Test your self",
      value: "How is [the] {Weather} ?",
      validation: false,
    },
  });

  const setShowDialog = () => {
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
  };

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value, validation } });
  };

  return (
    <>
      <div onClick={setShowDialog} className="btn-manager btn-manager-primary">
        <Tooltip title={"Text Helper"}>
          <Icons.QuestionCircle size={25} />
        </Tooltip>
      </div>
      {show && (
        <Dialog
          open={show}
          TransitionComponent={Transition}
          keepMounted
          fullWidth={true}
          maxWidth={"md"}
          onClose={handleClose}
          aria-describedby="alert-dialog-delete"
        >
          <DialogTitle>{`Text manager`}</DialogTitle>
          <DialogContent>
            {show && (
              <Grid2 container spacing={2}>
                <Grid2 item size={{ sm: 6, xs: 12 }}>
                  <p>You can use the following techniques to style text:</p>
                  <div className="m-help-info-box">
                    <p>{`1. Add "[" and "]"`}</p>
                    <div className="m-help-info-box-example para-main">
                      <p>{`Text: This is [sample] text`}</p>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: decodeText(
                            `[Result:] This is [sample] text`
                          ),
                        }}
                      />
                    </div>
                  </div>
                  <div className="m-help-info-box">
                    <p>{`2. Add "{" and "}"`}</p>
                    <div className="m-help-info-box-example para-main">
                      <p>{`Text: This is {sample} text`}</p>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: decodeText(
                            `[Result:] This is {sample} text`
                          ),
                        }}
                      />
                    </div>
                  </div>
                  <div className="m-help-info-box">
                    <p>{`3. Add "@BR" to enter new line`}</p>
                    <div className="m-help-info-box-example para-main">
                      <p>{`Text: This is @BRsample text`}</p>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: decodeText(
                            `[Result:] This is @BRsample text`
                          ),
                        }}
                      />
                    </div>
                  </div>
                  <div className="m-help-info-box">
                    <p>{`4. Add "<-" and "->"`}</p>
                    <div className="m-help-info-box-example para-main">
                      <p>{`Text: This is <-sample-> text`}</p>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: decodeText(
                            `[Result:] This is <-sample-> text`
                          ),
                        }}
                      />
                    </div>
                  </div>
                </Grid2>
                <Grid2 item size={{ sm: 6, xs: 12 }}>
                  <p>Test your self :</p>
                  <div className="m-help-info-box">
                    <Inputer
                      id={"text"}
                      setValue={setValue.bind(this)}
                      value={controls["text"].value}
                      label={controls["text"].label}
                      placeholder={controls["text"].placeholder}
                      type={controls["text"].type}
                      multiLine={controls["text"].multiLine}
                      className="mb-2"
                    />
                    <div className="m-help-info-box-example para-main">
                      <p>{"Result :"}</p>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: decodeText(controls.text.value),
                        }}
                      />
                    </div>
                  </div>
                </Grid2>
              </Grid2>
            )}
          </DialogContent>
          <DialogActions>
            <MButton label={"Close"} color="secondary" onClick={handleClose} />
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}
